module.exports = __webpack_public_path__ + "static/img/l_ktzx.1a02439e.png";